export const ANC_BY_ID = {
    "0B5": "Asiento Estándar",
    "07X": "Carry on",
    "0GO": "Primera maleta",
    "0FA": "Segunda maleta",
    "0GP": "Tercera maleta",
    "071": "Instrumento en cabina",
    SPB: "Equipaje especial en bodega",
    "0BT": "Mascota en cabina",
    "037": "Mascota en bodega",
    "982": "Seguro",
    "0BW": "Starpass",
    "0BH": "Menor no acompañado",
    VPC: "Cambio a vuelo previo",
    VPR: "Cambio a vuelo posterior Dom Perú",
    VPP: "Cambio a vuelo posterior Inter Chile y Perú",
    "98I": "Cambio de nombre",
  };